
export class IViewresaPush {
    viewresa: {
        ruid: string,
        hasError: string,
    }
}